const token = process.env.REACT_APP_TOKEN;

function GetToken()
{
    return(token);
}

export default GetToken;